<template>
  <div id="Folder">
    <div>
      <div class="cu-bar bg-white solid-bottom margin-top">
        <div class="action">
          <text class="cuIcon-title text-orange"></text>
          {{loginInfo.rangename}} - {{loginInfo.rolename}}
        </div>
      </div>
      <div class="cu-bar bg-white solid-bottom">
        <div class="action">
          <text class="cuIcon-title text-orange"></text>收件箱
        </div>
        <div class="cu-bt round bg-cyan" @click="delShow()">功能</div>
      </div>
      <div class="cu-list menu-avatar">
        <div
          class="cu-item"
          v-for="(item,index) in el.ReceiveUploadList"
          :key="index+'-'+item.UploadID"
          :value="item.UploadID"
        >
          <div
            class="cu-avatar round lg fa fa-paper-plane"
            v-if="loginInfo.rolename == item.UserName||loginInfo.rolename == item.PostUserName"
          ></div>
          <div v-else-if="item.ReadState != 0" class="cu-avatar round lg fa fa-envelope-open-o"></div>
          <div v-else class="cu-avatar round lg fa fa-envelope-o"></div>
          <div class="content">
            <div class="text-grey" @click="getConversation(item.UploadID)">{{ item.Title }}</div>
            <div class="text-gray text-sm">
              <text class="cuIcon-infofill text-red margin-right-xs"></text>
              {{ item.Memo }}
            </div>
          </div>
          <div class="action">
            <div class="text-grey text-xs">{{item.UploadTime}}</div>
            <div class="cu-tag round bg-grey sm">{{ item.RangeName || item.PostUserName }}</div>
          </div>
          <div class="mov round cu-bt bg-grey" v-show="moveShow">
            <div>
              <router-link tag="div" :to="/UpFile/+ item.UploadID">回复</router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="cu-bar bg-white solid-bottom">
        <div class="action">
          <text class="cuIcon-title text-orange"></text>发件箱
        </div>
        <div class="cu-bt round bg-cyan" @click="uploaderBtn">发送</div>
      </div>
    </div>
    <div class="cu-list menu-avatar">
      <div
        class="cu-item"
        v-for="(item,index) in el.SendUploadList"
        :key="index+'-'+item.UploadID"
        :value="item.UploadID"
      >
        <div class="cu-avatar round lg fa fa-paper-plane"></div>
        <div class="content">
          <div class="text-grey" @click="getConversation(item.UploadID)">{{ item.Title }}</div>
          <div class="text-gray text-sm">
            <text class="cuIcon-infofill text-red margin-right-xs"></text>
            {{ item.Memo }}
          </div>
        </div>
        <div class="action">
          <div class="text-grey text-xs">{{item.UploadTime}}</div>
          <div class="cu-tag round bg-grey sm">{{ item.RangeName || item.PostUserName }}</div>
        </div>
        <div class="mov round cu-bt bg-red" v-show="moveShow">
          <div @click="DeleteUploadInfo(item.UploadID)">删除</div>
        </div>
      </div>
    </div>
    <!-- <div class="cu-btn block bg-cyan margin-tb-sm lg flxed" @click="uploaderBtn">
        <text class="cuIcon-title text-orange"></text>发送文件
    </div>-->
  </div>
</template>
<script>
export default {
  name: "Folder",
  data() {
    return {
      id: "uploadFile",
      loginInfo: {},
      el: [], //会话列表
      moveShow: false
    };
  },
  methods: {
    delShow() {
      this.moveShow = !this.moveShow;
    },
    //跳转会话页面
    getConversation(uploadID) {
      //更新文件阅读人信息

      this.apiReadStatePut(
        { UploadID: uploadID, WorkID: this.getWork().work.WorkID },
        this, // eslint-disable-next-line
        (e, jsonObj) => {}
      );
      this.$router.push({ name: "ConverSation", params: { id: uploadID } });
    },
    //跳转到文件上传页面
    uploaderBtn() {
      this.$router.push({ name: "UpFile", params: { id: 0 } });
    },
    // 删除
    DeleteUploadInfo(uploadID) {
      var btnArray = ["取消", "确定"];
      this.$mui.confirm("", "确定删除文件?", btnArray, json => {
        if (json.index == 1) {
          this.apiReadStatePut(
            {
              UploadID: uploadID,
              WorkID: this.getWork().work.WorkID,
              DeleteUpload: true
            },
            this,
            e => {
              if (e.result == 1) {
                this.apiUploadGetData();
                this.$mui.toast("删除成功", { duration: "short" });
              } else {
                this.$mui.alert(e.msg, "提示", "确定", function() {});
              }
            }
          );
        } else {
          // eslint-disable-next-line
        }
      });
    },

    //获取考务文件列表
    apiUploadGetData() {
      this.apiUploadGet(
        {
          WorkID: this.getWork().work.WorkID
        },
        this,
        e => {
          this.el = e;
          // eslint-disable-next-line
          console.log(e);
        }
      );
    }
  },
  created() {
    // eslint-disable-next-line
    console.log(this.getWork());
    if (this.getWork()) {
      this.loginInfo = {
        rangename: this.getWork().organ.OrganName,
        rolename: this.getWork().user.RealName,
        userid: this.getWork().user.UserID
      };
    } else {
      this.$mui.toast("请选择考试");
      this.$router.push({ path: "/ExamManage" });
    }
    this.apiUploadGetData();
  },
  mounted() {
    this.$mui.init(
      this.$mui(".mui-scroll-wrapper").scroll({
        scrollY: true, //是否竖向滚动
        scrollX: false, //是否横向滚动
        startX: 0, //初始化时滚动至x
        startY: 0, //初始化时滚动至y
        indicators: true, //是否显示滚动条
        deceleration: 0.0006, //阻尼系数,系数越小滑动越灵敏
        bounce: true //是否启用回弹
      })
    );
  }
};
</script>
<style scoped>
.cu-bt {
  position: relative;
  border: 0px;
  display: -webkit-inline-box;
  display: -webkit-inline-flex;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0 16px;
  font-size: 15px;
  height: 35px;
  line-height: 1;
  text-align: center;
  text-decoration: none;
  overflow: visible;
  margin-left: initial;
  -webkit-transform: translate(0px, 0px);
  -ms-transform: translate(0px, 0px);
  transform: translate(0px, 0px);
  margin-right: initial;
  color: #ffffff;
}
.bg-white {
  background-color: #ffffff;
  color: #666666;
}
.margin-top {
  margin-top: 16px;
}
.cu-bar {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  position: relative;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  min-height: 54px;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
}
.cu-bar .action {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  height: 100%;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  max-width: 100%;
}
.bg-white {
  background-color: #ffffff;
  color: #666666;
}
.nav {
  white-space: nowrap;
}
.text-center {
  text-align: center;
}
.flex {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}
.uni-scroll-view {
  position: relative;
  -webkit-overflow-scrolling: touch;
  width: 100%;
  height: 100%;
  max-height: inherit;
}
.textNan {
  width: 100%;
  text-align: center;
}
.deleteBtn {
  font-size: 1px;
  padding: 39px;
  color: #007aff;
}
.folderDetails {
  position: absolute;
  bottom: 10%;
}
.cu-list.menu-avatar > .cu-item {
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  padding-right: 2px;
  margin: 1px 0 1px 0;
  height: 67px;
  background-color: #ffffff;
  -webkit-box-pack: end;
  -webkit-justify-content: flex-end;
  -ms-flex-pack: end;
  justify-content: flex-end;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  border-bottom: 1px solid #eeeeee;
}
.cu-list > .cu-item {
  -webkit-transition: all 0.6s ease-in-out 0s;
  -o-transition: all 0.6s ease-in-out 0s;
  transition: all 0.6s ease-in-out 0s;
  -webkit-transform: translateX(0px);
  -ms-transform: translateX(0px);
  transform: translateX(0px);
}
.cu-list.menu-avatar > .cu-item > .cu-avatar {
  position: absolute;
  left: 7px;
}
.cu-avatar.lg {
  width: 46px;
  height: 46px;
  font-size: 2em;
}
.cu-avatar {
  font-variant: small-caps;
  margin: 0;
  padding: 0;
  display: -webkit-inline-box;
  display: -webkit-inline-flex;
  display: -ms-inline-flexbox;
  display: inline-flex;
  text-align: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  background-color: #ccc;
  color: #ffffff;
  white-space: nowrap;
  position: relative;
  width: 15px;
  height: 15px;
  background-size: cover;
  background-position: center;
  vertical-align: middle;
  font-size: 1.5em;
}
.round {
  border-radius: 1200px;
}
.cu-list.menu-avatar > .cu-item .content {
  position: absolute;
  left: 70px;
  width: calc(100% - 93px - 94px - 28.5px - 4.5px);
  line-height: 1em;
}
.cu-list.menu-avatar > .cu-item .content > div:first-child {
  font-size: 14px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}
.text-sm {
  font-size: 5.5px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.cu-list.menu-avatar > .cu-item .action {
  width: 140px;
  text-align: center;
}
.text-xs {
  font-size: 9px;
}
.cu-list.menu-avatar > .cu-item .action uni-view + uni-view {
  margin-top: 4px;
}
.cu-tag.sm {
  font-size: 9px;
  padding: 0px 5px;
  height: 15px;
}
.bg-grey {
  background-color: #8799a3;
  color: #ffffff;
}
.cu-tag {
  font-size: 11px;
  vertical-align: middle;
  position: relative;
  display: -webkit-inline-box;
  display: -webkit-inline-flex;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0px 7px;
  height: 23px;
  font-family: Helvetica Neue, Helvetica, sans-serif;
  white-space: nowrap;
}
.uploaderBtn {
  position: fixed;
  bottom: 12%;
  right: 2%;
  width: 4rem;
  height: 4rem;
  border-radius: 4rem;
  background: #0081ff;
  text-align: center;
  padding: 0.5rem;
  color: #ffffff;
  -webkit-box-shadow: 2px 2px 3px rgba(108, 95, 95, 0.5);
  box-shadow: 2px 2px 3px rgba(108, 95, 95, 0.5);
}
.cu-list + .cu-list {
  margin-top: 0;
}
.cu-list > .cu-item .mov {
  left: 66%;
  width: 95px;
  height: 50%;
  position: absolute;
}
</style>
